import { render } from "./Fade.vue?vue&type=template&id=4e5a1ade&scoped=true"
import script from "./Fade.vue?vue&type=script&lang=js"
export * from "./Fade.vue?vue&type=script&lang=js"

import "./Fade.vue?vue&type=style&index=0&id=4e5a1ade&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5a1ade"]])

export default __exports__